import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
const WEBHOOK_URL = 'https://services.leadconnectorhq.com/hooks/mmuChs2XqH3KvF4a7fk2/webhook-trigger/f07449ae-fa29-4633-b702-bd3257d6fdd8';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    const formData = new FormData(e.currentTarget);
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      if (typeof value === 'string') data[key] = value;
    });
    // Send to webhook via query params (bypasses all CORS restrictions)
    try {
      const params = new URLSearchParams(data);
      const img = new Image();
      img.src = `${WEBHOOK_URL}?${params.toString()}`;
      setIsSubmitting(false);
      setIsSuccess(true);
    } catch (err) {
      setIsSubmitting(false);
      setError('Something went wrong. Please try again.');
    }
  };
  return <div className="w-full pt-20 pb-24 bg-engage-black min-h-screen" data-id="element-723">
      <div className="max-w-5xl mx-auto px-4" data-id="element-724">
        {/* Hero */}
        <div className="text-center mb-16 pt-20" data-id="element-725">
          <h1 className="text-5xl md:text-6xl font-black text-engage-white mb-6 tracking-tight" data-id="element-726">
            Contact Us
          </h1>
          <p className="text-xl text-engage-yellow font-medium" data-id="element-727">
            How can we help?
          </p>
        </div>

        {/* Form Card */}
        <Card className="!p-8 md:!p-12" data-id="element-728">
          {isSuccess ? <div className="text-center py-16" data-id="element-729">
              <div className="w-20 h-20 bg-engage-yellow/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-730">
                <svg className="w-10 h-10 text-engage-yellow" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-731">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-732" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-733">Request Received</h2>
              <p className="text-engage-gray4 text-lg mb-8" data-id="element-734">
                Thank you for reaching out. Our growth team will review your
                information and get back to you within 24 hours to schedule your
                strategy session.
              </p>
              <Button onClick={() => setIsSuccess(false)} variant="secondary" data-id="element-735">
                Submit Another Request
              </Button>
            </div> : <form onSubmit={handleSubmit} className="space-y-8" data-id="element-736">
              {error && <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4 text-red-400 text-center" data-id="element-737">
                  {error}
                </div>}

              {/* Name Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-738">
                <Input label="First Name" name="firstName" placeholder="John" data-id="element-739" />
                <Input label="Last Name" name="lastName" placeholder="Doe" data-id="element-740" />
              </div>

              {/* Contact Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-741">
                <Input label="Email Address" name="email" type="email" placeholder="john@company.com" data-id="element-742" />
                <Input label="Phone Number" name="phone" type="tel" placeholder="+1 (555) 000-0000" data-id="element-743" />
              </div>

              {/* Company Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-744">
                <Input label="Company Name" name="companyName" placeholder="Acme Corp" data-id="element-745" />
                <Input label="Website URL" name="websiteUrl" type="url" placeholder="https://company.com" data-id="element-746" />
              </div>

              {/* Dropdowns Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-747">
                <Input label="Industry" name="industry" as="select" options={[{
              value: 'ecommerce',
              label: 'E-commerce'
            }, {
              value: 'local_service',
              label: 'Local Services'
            }, {
              value: 'b2b',
              label: 'B2B / SaaS'
            }, {
              value: 'finance',
              label: 'Financial Services'
            }, {
              value: 'health',
              label: 'Health & Wellness'
            }, {
              value: 'other',
              label: 'Other'
            }]} data-id="element-748" />
                <Input label="Monthly Marketing Budget" name="monthlyBudget" as="select" options={[{
              value: '2k-5k',
              label: '$2,000 - $5,000'
            }, {
              value: '5k-10k',
              label: '$5,000 - $10,000'
            }, {
              value: '10k-20k',
              label: '$10,000 - $20,000'
            }, {
              value: '20k+',
              label: '$20,000+'
            }]} data-id="element-749" />
              </div>

              <Input label="How did you hear about us?" name="howDidYouHear" as="select" options={[{
            value: 'social',
            label: 'Social Media'
          }, {
            value: 'referral',
            label: 'Referral / Word of Mouth'
          }, {
            value: 'website',
            label: 'Website'
          }, {
            value: 'google',
            label: 'Google'
          }, {
            value: 'other',
            label: 'Other'
          }]} data-id="element-750" />

              {/* Textarea */}
              <Input label="What marketing are you currently doing?" name="currentMarketing" as="textarea" placeholder="Tell us about your current channels, challenges, and goals..." data-id="element-751" />

              {/* Submit */}
              <Button type="submit" variant="primary" fullWidth className="text-lg py-4 mt-8" disabled={isSubmitting} data-id="element-752">
                {isSubmitting ? 'Submitting...' : 'Book a Call With Us'}
              </Button>
            </form>}
        </Card>
      </div>
    </div>;
}